export default __webpack_public_path__ + "static/media/lock-reset.00b8beb0.svg";